import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SelectedCompanyService } from './selected-company.service';

@Injectable()
export class SelectedCompanyInterceptor implements HttpInterceptor {
	/** The company id header used to set on the request */
	private readonly COMPANY_ID_HEADER: string = 'X-company-id';

	constructor(private selectedCompanyService: SelectedCompanyService) {}

	intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
		const companyId = this.selectedCompanyService.getSelectedCompanyID();
		if (companyId != null) {
			request = request.clone({
				headers: request.headers.set(this.COMPANY_ID_HEADER, companyId.toString()),
			});
		}
		return next.handle(request);
	}
}
